import { constants, useWindowSize } from "@newsela/angelou";

import ErrorBoundary from "@/components/ErrorBoundary";
import { Assignment } from "@/types/models/Assignment.interface";
import { ContentLevel } from "@/types/models/ContentLevel.interface";
import { User } from "@/types/models/User.interface";
import MobileActions from "@/view/ActionsToolbar/MobileActions";
import { ArticleType } from "@/view/constants/articleTypes";
import { ContentType } from "@/view/constants/contentTypes";
import SecondaryActions from "@/view/SecondaryActions";
import usePresentModeContext from "@/view/utils/usePresentModeContext";
import { DISABLED_FEATURES } from "../SecondaryActions/SecondaryActions";
import { rootCss } from "./SecondaryActionsToolbar.style";

interface SecondaryActionsToolbarProps {
  bannerMode: {
    toggleBannerMode: () => void;
    canUseBannerMode: boolean;
  };
  content: {
    id: string;
    content_type: ContentType;
    data?: {
      article_type: ArticleType;
      content_id: string;
      thumbnail: string;
    };
  };
  currentLevel: ContentLevel | undefined;
  matchedAssignments: Assignment[];
  readAloudButtonRef: object | undefined;
  shouldShowMobileActions: boolean;
  user: User;
  userProperties: { isTeacher: boolean; isParent: boolean; isStudent: boolean };
  disabledFeatures?: DISABLED_FEATURES[];
}
const SecondaryActionsToolbar = ({
  bannerMode,
  content,
  currentLevel,
  matchedAssignments,
  readAloudButtonRef,
  shouldShowMobileActions,
  user,
  userProperties,
  disabledFeatures = [],
}: SecondaryActionsToolbarProps) => {
  const { isVideoPresentModeActive } = usePresentModeContext();

  const { width: windowWidth } = useWindowSize();
  const {
    breakpoints: {
      Breakpoints: { lg },
    },
  } = constants;
  const isMobile = windowWidth <= lg;

  if (isVideoPresentModeActive || shouldShowMobileActions) {
    return null;
  }

  return (
    <div css={rootCss}>
      <ErrorBoundary>
        <SecondaryActions
          bannerMode={bannerMode}
          content={content}
          currentLevel={currentLevel}
          isMobile={isMobile}
          matchedAssignments={matchedAssignments}
          readAloudButtonRef={readAloudButtonRef}
          user={user}
          userProperties={userProperties}
          disabledFeatures={disabledFeatures}
        />
        {isMobile && (
          <MobileActions
            bannerMode={bannerMode}
            content={content}
            currentLevel={currentLevel}
            matchedAssignments={matchedAssignments}
            user={user}
            userProperties={userProperties}
            disabledFeatures={disabledFeatures}
          />
        )}
      </ErrorBoundary>
    </div>
  );
};

export default SecondaryActionsToolbar;
